
import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'src/assets/fonts/vfs_fonts.js';
import * as checkboxFalse from '!raw-loader!src/assets/images/icon/checkbox-f.svg';
import * as checkboxTure from '!raw-loader!src/assets/images/icon/checkbox-t.svg';
import * as eng from 'src/assets/i18n/en.json';
import * as th from 'src/assets/i18n/th.json';


pdfMake.vfs = pdfFonts.pdfMake.vfs;
    function checkboxImg(data){
    if(data == true){
        return checkboxTure.default
    }else{
        return checkboxFalse.default
    }
}

const openPDF = (data) => {
    console.log(data)
    let lang: any
    let headerMagin = []
    if (data.lang === 'en') {
        lang = eng.default
        headerMagin = [0, 10, 80, 0]
    } else {
        lang = th.default
        headerMagin = [0, 10, 60, 0]
    }
    const docDefinition = {
        defaultStyle: {
            font: "DBOZONEX"
        },
        content: [
            {
                alignment: 'center',
                columns: [
                    {
                        image: data.logoTL,
                        width: 70,
                        alignment: 'left',

                    },
                    {
                        text: lang.R0000.R0001,
                        fontSize: 22,
                        bold: true,
                        margin: headerMagin
                    }
                ]
            },
            '\n',
            {
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0007 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 100,
                        text: data.concurrentData.referenceNo
                    },
                    {
                        width: 110,
                        text: lang.R0000.R0008 + " :",
                        alignment: 'right',

                    },
                    {
                        width: '*',
                        text: data.concurrentData.policyNo
                    },
                ],
                columnGap: 5
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0009 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 100,
                        text: data.concurrentData.hospName
                    },
                    {
                        width: 110,
                        text: lang.R0000.R0010 + " :",
                        alignment: 'right',

                    },
                    {
                        width: '*',
                        text: data.concurrentData.name
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0011 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 100,
                        text: data.concurrentData.submitReportDate
                    },
                    {
                        width: 110,
                        text: lang.R0000.R0012 + " :",
                        alignment: 'right',


                    },
                    {
                        width: '*',
                        text: data.concurrentData.seqNo
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0013 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 100,
                        text: data.concurrentData.admitDate
                    },
                    {
                        width: 110,
                        text: lang.R0000.R0014 + " :",
                        alignment: 'right',


                    },
                    {
                        width: '*',
                        text:  data.concurrentData.accidentDate
                    },
                ]
            },
            '\n',
            {
                canvas: [
                    { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }
                ]
            },
            '\n',
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0015 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 100,
                        text: data.concurrentData.hn
                    },
                    {
                        width: 110,
                        text: lang.R0000.R0016 + " :",
                        alignment: 'right',
                    },
                    {
                        width: '*',
                        text: data.concurrentData.roomNo
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0017 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 350,
                        text: data.concurrentData.diagnosisName
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0018 + " :",
                        alignment: 'right',
                    },
                    {
                        width: 350,
                        text: data.concurrentData.additionalCauses
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0019 + " :",
                        alignment: 'right',
                    },
                    {
                        width: 350,
                        text: data.concurrentData.introduction
                    },
                ]
            },
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0020 + " :",
                        alignment: 'right',
                    },
                    {
                        width: 350,
                        text: data.concurrentData.underlying
                    },
                ]
            },
            '\n',
            {
                canvas: [
                    { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }
                ]
            },
            '\n',
            {
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.needIvfRate),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 90,
                        text: lang.R0000.R0022 + " :",
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 30,
                        text: data.concurrentData.ivfRate,
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 30,
                        text: lang.R0000.R0023,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: '',
                        width: 70
                    },
                    {
                        svg: checkboxImg(data.concurrentData.noIndicationForAdmit),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: '*',
                        text: lang.R0000.R0024,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            {
                margin: [0, 8, 0, 0],
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.needMedicalIvf),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 90,
                        text: lang.R0000.R0025 + "",
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 30,
                        text: '',
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 30,
                        text: '',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: '',
                        width: 70
                    },
                    {
                        svg: checkboxImg(data.concurrentData.needRecordNeuroSign),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: '*',
                        text: lang.R0000.R0026,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            {
                margin: [0, 8, 0, 0],
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.vsUnstable),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 90,
                        text: lang.R0000.R0027,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 15,
                        text: lang.R0000.R0028 + " :",
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 50,
                        text: data.concurrentData.vsUnstableT,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 15,
                        text: lang.R0000.R0029 + " :",
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: data.concurrentData.vsUnstableP,
                        width: 50,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 15,
                        text: lang.R0000.R0030 + " :",
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: data.concurrentData.vsUnstableR,
                        width: 50,
                        margin: [0, -3, 0, 0]

                    },
                    {
                        width: 20,
                        text: lang.R0000.R0031 + " :",
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: '*',
                        text: data.concurrentData.vsUnstableBp,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            {
                margin: [0, 8, 0, 0],
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.surgery),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 45,
                        text: lang.R0000.R0032 + " :",
                        margin: [0, -3, 0, 0]
                    },
                    // {
                    //     width: 30,
                    //     text: '',
                    //     alignment: 'right',
                    //     margin: [0, -3, 0, 0]
                    // },
                    {
                        width: 115,
                        text: data.concurrentData.severePainDetail,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: lang.R0000.R0033 + " :",
                        width: 80,
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: '*',
                        text: data.concurrentData.surgeryDate,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            {
                margin: [0, 8, 0, 0],
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.severePain),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 130,
                        text: lang.R0000.R0034 + " :",
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 30,
                        text: data.concurrentData.severePainDetail+" )",
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: '',
                        width: 65
                    },
                    {
                        svg: checkboxImg(data.concurrentData.patientRequest),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: '*',
                        text: lang.R0000.R0035,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            {
                margin: [0, 8, 0, 0],
                columnGap: 5,
                fontSize: 14,
                columns: [
                    {
                        text: '',
                        width: 80
                    },
                    {
                        svg: checkboxImg(data.concurrentData.pt),
                        width: 10,
                        alignment: 'right',
                    },
                    {
                        width: 20,
                        text: lang.R0000.R0036,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 45,
                        text: data.concurrentData.ptDetail,
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: 70,
                        text: lang.R0000.R0037,
                        margin: [0, -3, 0, 0]
                    },
                    {
                        text: '',
                        width: 80
                    },
                
                    {
                        text: 'Other :',
                        width: 50,
                        alignment: 'right',
                        margin: [0, -3, 0, 0]
                    },
                    {
                        width: '*',
                        text: data.concurrentData.other,
                        margin: [0, -3, 0, 0]
                    },
                ]
            },
            '\n',
            {
                canvas: [
                    { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }
                ]
            },
            '\n',
            {
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0038 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 350,
                        text: data.concurrentData.expectedLos+" "+lang.R0000.R0050
                    },
                ],
                columnGap: 5
            },
            {
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0039 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 350,
                        text: data.concurrentData.reporter
                    },
                ],
                columnGap: 5
            },
            {
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0040 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 150,
                        text: data.concurrentData.tellNo
                    },
                    {
                        width: 80,
                        text: lang.R0000.R0041 + " :",
                        alignment: 'right',

                    },
                    {
                        width: 150,
                        text: data.concurrentData.faxNo
                    },  
                ],
                columnGap: 5
            },
            {
                fontSize: 14,
                columns: [
                    {
                        width: 150,
                        text: lang.R0000.R0042 + " :",
                        alignment: 'right',

                    },
                    {
                        width: '*',
                        text: data.concurrentData.email
                    },
                ],
                columnGap: 5
            },
            '\n\n\n\n\n',
            {
                fontSize: 14,
                alignment: 'left',
                bold: true,
                text: lang.R0000.R0046,
            },
            '\n',
            {
                stack: [
                    lang.R0000.R0049,
                    { text: lang.R0000.R0040 + ' 02-246-2249 ' + lang.R0000.R0041 + ' 02-246-9944' },
                    { text: lang.R0000.R0042 + ' : tlconcurrent@thailife.com' },
                ],
                alignment: 'right',
                fontSize: 14,
                bold: true,
            },

        ],

        styles: {
            align: {
                alignment: 'right',
            },
            subheader: {
                fontSize: 14
            },
            superMargin: {
                margin: [20, 0, 40,],
                fontSize: 15
            }
        }

    };
    pdfMake.fonts = {
        DBOZONEX: {
            normal: "DB Ozone X-normal.ttf",
            bold: "DB Ozone X Bd.ttf"
        }
    };
    let base64: any



    return new Promise((resolve, reject) => {
        try {
            pdfMake.createPdf(docDefinition).getBase64((data: any) => {
                resolve(data);
            });

           // pdfMake.createPdf(docDefinition).open();
        } catch (err) {
            reject(err);
        }
    });
};

export default openPDF;
